import classnames from 'classnames';
import './CustomButton.scss';

type Props = {
    label: string;
    onClick: Function;
    disabled?: boolean;
    icon?: string;
    reverse?: boolean;
    className?: string;
};

const CustomButton: React.FC<Props> = ({ className, label, onClick, disabled = false, icon, reverse = false }) => (
    <button
        className={classnames(icon ? 'button-withIcon' : 'button', className)}
        onClick={() => onClick()}
        disabled={disabled}
    >
        {reverse ? (
            <div>
                <span className="mr-2">{label}</span>
                <span className={classnames(icon && `fas ${icon}`, disabled && 'icon-disabled')} />
            </div>
        ) : (
            <div>
                <span className={classnames(icon && `fas ${icon}`, disabled && 'icon-disabled')} />
                <span className="ml-2">{label}</span>
            </div>
        )}
    </button>
);

export default CustomButton;
